import React, { useEffect, useState } from "react";
import Header from "../component/Header";
import SubBanner from "../component/SubBanner";
import GetInTouch from "../component/GetInTouch";
import HomeCareers from "../component/HomeCareers";
import Footer from "../component/Footer";
import "../scss/resources.scss";
import "../scss/sub-banner.scss";

import { useSelector } from "react-redux";
import { Helmet } from "react-helmet-async";

function ContactUs() {
  const [homeData, setHomeData] = useState(null);
  const [contactData, setContactData] = useState(null);
  const { pageResponse } = useSelector((state) => state.visitor);

  useEffect(() => {
    if (pageResponse) {
      let home = pageResponse.find((r) => r.code === "home");
      setHomeData(home.home_section);
      let con = pageResponse.find((r) => r.code === "contact-us");
      setContactData(con.contact_us_section);
    }
  }, [pageResponse]);

  return (
    <>
      <Helmet>
        <title>Contact Us | Helpotani</title>
        <meta name="description" content="" />
        <meta name="keywords" content="" />
      </Helmet>

      <main className="resources-page">
        <Header />
        <SubBanner HeaderTitle="Contact Us" />
        <GetInTouch data={contactData ? contactData : null} />
        <HomeCareers data={homeData?.section_6 ? homeData.section_6 : null} />
      </main>
      <Footer />
    </>
  );
}
export default ContactUs;
